module.exports = __webpack_public_path__ + "img/top-4-1.f061ca19.jpg";